import React from 'react';
import { Content, StickyPositionedHeader, StaticPositionedHeader } from './styles';

function getHeaderComponent(props) {
  var fixed = props.fixed;
  var HeaderComponent;

  if (fixed) {
    HeaderComponent = StickyPositionedHeader;
  } else HeaderComponent = StaticPositionedHeader;

  return HeaderComponent;
}

export var Header = function Header(props) {
  var children = props.children,
      style = props.style,
      className = props.className,
      constrainWidth = props.constrainWidth,
      disableGutter = props.disableGutter,
      left = props.left,
      right = props.right;
  var Component = getHeaderComponent(props);
  return /*#__PURE__*/React.createElement(Component, {
    style: style,
    className: className
  }, /*#__PURE__*/React.createElement(Content, {
    disableGutter: disableGutter,
    constrainWidth: constrainWidth,
    left: left,
    right: right
  }, children));
};
Header.defaultProps = {
  fixed: false,
  isPageChild: false
};
export default Header;
/**
 * Header that is child of a page should default to fixed. Only the page child should be fixed - everything
 */